import Input from '../Inputs/input';

export default function BillingInfoForm({ data, errors, updateBillingInfoFormData }) {
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        updateBillingInfoFormData({ ...data, [name]: value });
    };

    return (
        <div className="grid gap-8 grid-cols-2">
            <Input label="nameSociety" name="nameSociety" value={data.nameSociety} onChange={handleInputChange} required={false} />
            <Input label="siret" name="siret" value={data.siret} onChange={handleInputChange} required={false} />
            <Input label="numTVA" name="numTVA" value={data.numTVA} onChange={handleInputChange} required={false} />
            <Input label="country" name="country" value={data.country} error={errors.country} onChange={handleInputChange} required={true} />
            <Input label="city" name="city" value={data.city} error={errors.city} onChange={handleInputChange} required={true} />
            <Input label="address" name="address" value={data.address} error={errors.address} onChange={handleInputChange} required={true} />
            <Input label="postalCode" name="postalCode" value={data.postalCode} error={errors.postalCode} onChange={handleInputChange} required={true} />
            <Input label="address2" name="address2" value={data.address2} onChange={handleInputChange} required={false} />
        </div>
    )
};